import variables from "@/utils/variables";

export default function formatPurpose(v) {
  for (let t of variables.purpose) {
    if (v == t.value) {
      return t.text;
    }
  }

  return;
}
